var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.002 18.7542L19.252 26.1154L21.2496 22.0753L25.7472 22.3654L21.4972 15.0042M8.50195 15.0042L4.25195 22.3654L8.74955 22.0753L10.7471 26.1154L14.9971 18.7542M22.4996 11.25C22.4996 15.3921 19.1417 18.75 14.9996 18.75C10.8574 18.75 7.49957 15.3921 7.49957 11.25C7.49957 7.10786 10.8574 3.75 14.9996 3.75C19.1417 3.75 22.4996 7.10786 22.4996 11.25Z",
    stroke: "#FC68B4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.057 14.699V14.849H13.207H16.707H16.857V14.699V14.0942V13.9442H16.707H15.5383V8.37329V8.22329H15.3883H14.8331H14.7922L14.757 8.244C14.4391 8.43103 14.0407 8.57484 13.4885 8.67172L13.3644 8.69349V8.81946V9.28547V9.43547H13.5144H14.5145V13.9442H13.207H13.057V14.0942V14.699Z",
    fill: "#FC68B4",
    stroke: "#FC68B4",
    strokeWidth: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.e93aaac24b099454613c1a41d14caecd.svg";
export { ForwardRef as ReactComponent };